<div class="container-add">
    <div class="container-add__video">
        <iframe 
        width="853"
        height="480"
        src="https://www.youtube.com/embed/93snQe9ITFk?si=mZL5AN4tolyPa0Y8"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        ></iframe>
    </div>

    <ng-container *ngIf="!emailIsSended">
        <h1 class="container-add__title">
        {{ 'handover.activate-functionality' | translate }}
        </h1>
        <span class="container-add__desc">
        {{ 'handover.activate-functionality-description' | translate }}
        </span>
        <button (click)="sendEmail()" class="container-add__submit">
        {{ 'handover.activate-functionality-im-interested' | translate }}
        </button>
    </ng-container>

    <div *ngIf="emailIsSended" class="container-add__email-sended">
        <img src="/assets/img/check.svg" class="check" alt="img">
        <span class="container-add__title">
            {{ 'handover.activate-functionality-success-title' | translate }}
        </span>
        <span class="container-add__desc">
            {{ 'handover.activate-functionality-success-desc' | translate }}
        </span>
    </div>
</div>
